interface Props {
  [key: string]: any;
}

function PluginPlaceholder(_props: Props): JSX.Element | null {
  return null;
}

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default PluginPlaceholder;
